<template>
    <Dialog v-model="show" :title="'HISTÓRICO DE ENVIO DE '+tipoHistorico.toUpperCase()" width="800">
        <v-simple-table>
            <thead>
                <tr>
                    <td>{{ tipoHistorico === 'contrato' ? 'Data e hora do envio' : 'Status' }}</td>
                    <td>{{ tipoHistorico === 'contrato' ? 'Funcionalidade' : 'Data e Hora do Envio' }}</td>
                    <td>{{ tipoHistorico === 'contrato' ? 'Operação' : 'E-mail' }}</td>
                    <td v-if="tipoHistorico !== 'contrato'">Origem</td>
                </tr>
            </thead>
            <tbody>
                <!--suppress JSUnresolvedVariable -->
                <tr v-for="envio in historico" :key="envio.id_historico_envio_boleto">
                    <td>{{ tipoHistorico === 'contrato' ? toDateTimeBR(envio.data_hora_envio) : primeiraMaiscula(envio.status) }}</td>
                    <td>{{ tipoHistorico === 'contrato' ? envio.funcionalidade : toDateTimeBR(envio.data_hora_envio) }}</td>
                    <td>{{ tipoHistorico === 'contrato' ? envio.operacao : envio.email }}</td>
                    <td v-if="tipoHistorico !== 'contrato'">{{ envio.origem !== '' ? envio.origem : '-' }}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <div class="d-flex justify-center">
            <v-btn color="primary" @click="dismiss">OK</v-btn>
        </div>
    </Dialog>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'DialogHistoricoBoleto',
    props: {
      value: Boolean,
      tipoHistorico: String,
      historico: Array
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      dismiss () {
        this.show = false
      },
      primeiraMaiscula (value) {
        return value
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ')
      },
      toDateTimeBR (value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss.uuu').format('DD/MM/YYYY H:mm:ss')
      }
    }
  }
</script>

<style scoped>

</style>
